import { yupResolver } from '@hookform/resolvers/yup';
import { ButtonV2, HfInput } from '@myosh/odin-components';
import i18next from 'i18next';
import { type FieldValues, useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import * as yup from 'yup';
import { checkIdp } from '../helpers/check-idp';
import Footer from './footer.component';
import Sidebar from './sidebar.component';

export interface LoginFormProps {
  setIdp: (domain: string) => void;
}

const schema = yup.object().shape({
  email: yup
    .string()
    .required(() => i18next.t('email-required'))
    .email(),
});

export default function LoginForm({ setIdp }: LoginFormProps) {
  const { t } = useTranslation();
  const {
    control,
    handleSubmit,
    formState: { errors },
  } = useForm<FieldValues>({
    resolver: yupResolver(schema) as never,
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
  });

  const onSubmit = async (data: FieldValues) => {
    if (data.email !== '') {
      const idp = await checkIdp(data.email);
      return setIdp(idp);
    }
  };

  return (
    <div className="myl-login-layout flex h-full min-h-screen w-full flex-col sm:flex-row">
      <Sidebar />
      <div className="flex min-w-0 flex-1 flex-col">
        <div className="flex max-w-sm flex-1 flex-col justify-center px-8 pb-12 md:ml-24 md:px-0">
          <h2 className="mt-8 mb-6 font-bold text-6xl sm:mt-12">{t('welcome')}</h2>
          <p className="mb-4 sm:text-xl md:text-2xl">{t('log-in-to-myosh')}</p>
          <form className="flex flex-col gap-4" onSubmit={handleSubmit(onSubmit)}>
            <HfInput
              name="email"
              type="email"
              placeholder={t('enter-username')}
              control={control}
              error={errors.email?.message as string | undefined}
              enableDebounce={false}
            />
            <ButtonV2 type="submit" size="lg" className="self-start px-4">
              {t('log-in')}
            </ButtonV2>
          </form>
        </div>
        <Footer />
      </div>
    </div>
  );
}
